import { debugLogTime } from "../utils/common";

export const UPDATE_LOADING_STATE = "loadingState.UPDATE";

export function updateLoadingState(loadingState) {
  debugLogTime("updateLoadingState", loadingState, "actions");

  return {
    type: UPDATE_LOADING_STATE,
    loadingState,
  };
}
